import {useEffect,useState } from 'react'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import { getSolicitudTipo } from '../request/request'
import { useAppSelector } from '../../../../../redux/hooks'
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/plain.css'


const API_URL = process.env.REACT_APP_API_URL


export default function ProblemReport(props:any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  // eslint-disable-next-line
    const [loading, setLoading] = useState(false)
    const [TipoSol, setTipoSol] = useState('');
    const [Resumen, setResumen] = useState('');
    const [Prioridad, setPrioridad] = useState('');
    const [Descripcion, setDescripcion] = useState('');
    const [files, setfiles] = useState<File[]>();
    const [Contacto,setContacto] = useState('');
    const [Correo,setCorreo] = useState('');
    const [TercerNivel, setTercerNivel] = useState('');
    const [phone_number,setPhone_number] = useState('');
    const [product, setproduct] = useState('');


    const navigate = useNavigate();
    ////////////////////////////////////////



    //************************************************************************************** */
    const [nivel,setnivel]= useState([])

    useEffect( () => {
      if(TipoSol !== ' ' ){
      axios.get(API_URL+'/v1/support/list_two_level?type=Change Request&twolevel='+TipoSol+'&product='+product)
      .then(res=>{
          setnivel(res.data)
      })
      }
      else{
        setnivel([])
      }
   }, [TipoSol])
    //************************************************************************************** */

    
    const [Tipo, setTipo] = useState<any>([])

    useEffect( () => {
        getSolicitudTipo(product).then(response => {
         setTipo(response.data)
         
        })
     }, [product])

   
    useEffect( () => {
      if (product){
        setTipoSol('')
      }
   }, [product])




     const handleChange = (event:any) => {
      // eslint-disable-next-line
      const file = event.target.files[0]
      setfiles(
          event.target.files
      )}

     const handleSubmit =async (e:any) => {
      e.preventDefault();

      try{
        let id
        for(const x of Tipo){
          if (x.label === TipoSol){
              id=x.value
          }
        }
        var formData = new FormData();
        formData.append("Tipo", 'Change Request' )
        formData.append("product", product )
        formData.append("cloud", Type)
        formData.append("region", nameregion)
        /*formData.append("SuscripcionId", Suscripcion.id)*/
        formData.append("TipoSolicitud",id)
        formData.append("level_3",TercerNivel)
        formData.append("Resumen", Resumen);
        formData.append("Prioridad", Prioridad)
        formData.append("Descripcion", Descripcion)
        if(files){
          for(const x of files){
        formData.append("files[]", x);}}
        formData.append("Nombre_de_contacto", Contacto)
        formData.append("Correo", Correo)
        formData.append("phone_number", phone_number)
         await axios.post(API_URL+'/v1/support/CreatedTicket', formData,{
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })
        navigate('/support/SeeRequest')
      }
      catch(error:any){
        console.log(error)

      }

      
     }
     /////////////////////////
     const [isChecked, setIsChecked] = useState(false);

     
       const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
         setIsChecked(event.target.checked);
       };

      

    return(

        <>
              {/* begin::Row */}
              <div className='row g-5 g-xl-8'>
                <div className='col-xl-3'></div>
        
                <div className='col-xl-6'>
                    <div className="card card-custom ">
                        <div className="card-header align-items-center bg-marino ribbon ribbon-end ribbon-clip">
                            <Link to='/support/OpenRequest' className="ribbon-label text-marino">
                              Back
                              <span className="ribbon-inner bg-light-azul"></span>
                            </Link>
                            <h3 className="card-title text-secondary fw-bolder">CUSTOMER SUPPORT</h3>
                        </div>

                        <div className="card-body">
                        <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit}  >
                                {/* begin::Heading */}
                                <Card4
                                icon='/media/imgv2/logo_rosa_dos.png'
                                title=' '
                                description=''></Card4>
                                <div className='text-center mb-5'>
                                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Change Request</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                                    <div className='text-info'>
                                      Use this section to tell us about your <strong>Change</strong> requests.
                                    </div>
                                  
                                </div>
                                 {/* Campos solicitud */}
                                 <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-marino fs-6 mb-0 required form-label'>Product</label>
                                    <select 
                                     required
                                     id='Affected'
                                     value={product}
                                     onChange={(e) => setproduct(e.target.value)}

                                    className="form-select form-select-solid  border-gray-300 " aria-label="Select example">
                                      <option selected hidden>Select</option>
                                      <option className="text-marino" value="ctx-hub">CTX HUB</option>
                                      <option className="text-marino" value="ctx-r">CTX Reflector</option>
                                    </select>
                                </div> 
                                 <div className="d-flex flex-row-fluid flex-column-fluid f-parrafo ">
                                    <div className=" flex-row-fluid  flex-center col-5">
                                            <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Cloud</label>
                                            {Id !==0 ? <input
                                                type="text"
                                                className="form-control form-control-solid  border-gray-300  "
                                                disabled
                                                value={Type}
                                              />:
                                              <input
                                                required
                                                type="text"
                                                className="form-control form-control-solid border-primary  border-gray-300  text-danger "
                                                disabled
                                                value='Select a Cloud with available subscriptions'
                                              />
                                              }                                 
                                    </div>
                                        
                                    <div className=" d-flex flex-row-fluid  flex-center col-5 ">
                                        <div className='fv-row mb-8'>
                                            <label className='form-label fs-6 fw-bolder text-dark required form-label'>Region</label>
                                            {Id !==0 ? <input
                                                type="text"
                                                className="form-control form-control-solid  border-gray-300  "
                                                disabled
                                                value={nameregion}
                                              />:
                                              <input
                                                required
                                                type="text"
                                                className="form-control form-control-solid border-gray-300 text-danger "
                                                disabled
                                                value='Select a Cloud with available subscriptions'
                                              />
                                              }                                 
                                        </div>
                                    </div>
                                </div>
                                {/* Campos solicitud 
                                <div className='fv-row mb-8'>
                                  <label className='form-label fs-6 fw-bolder text-dark'>Suscripción</label>
                                  {Id !==0 ? <input
                                      type="text"
                                      className="form-control form-control-solid border-primary border-active "
                                      disabled
                                      value={Suscripcion.purchaseOrden}
                                    />:
                                    <input
                                      required
                                      type="text"
                                      className="form-control form-control-solid border-primary border-active text-danger "
                                      disabled
                                      value='Select a Cloud with available subscriptions'
                                    />
                                    }
                                 
                                </div>*/}
                                
                                {/* Campos solicitud */}
                                 <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>Topic</label>
                                  <select   id='TipoSol'
                                  required
                                  value={TipoSol}
                                  onChange={(e:any) => setTipoSol(e.target.value)} 
                                  className="form-select form-select-solid text-marino border-gray-300" aria-label="Select example">
                                    <option value="" disabled  selected hidden>Choose Request Topic</option>  
                                    {
                                        Tipo.map( (sus:any) =>
                                        <option  value={sus.label}>{sus.label}</option>
                                        )
                                      }
                                  </select>
                                </div>

                                {/* Campos solicitud */}
                                {nivel.length !== 0 && 
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>Specify your request</label>
                                  <select   id='TipoSol'
                                  required
                                  value={TercerNivel}
                                  onChange={(e:any) => setTercerNivel(e.target.value)} 
                                  className="form-select form-select-solid bg-light-info text-info border-gray-300" aria-label="Select example">
                                    <option value=""  selected hidden>Select an option</option>  
                                    {
                                        nivel.map( (sus:any) =>
                                        <option  value={sus.value}>{sus.label}</option>
                                        )
                                      }
                                  </select>
                                </div>}

                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>Title</label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control form-control-solid border-gray-300 "
                                      placeholder="Write a brief description"
                                      maxLength={150}
                                      id='Resumen'
                                      value={Resumen}
                                      onChange={(e) => setResumen(e.target.value)}

                                    />
                                </div>

                               

                                 {/* Campos solicitud */}
                                 <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-marino fs-6 mb-0 required form-label'>Priority</label>
                                    <select 
                                     required
                                     id='Prioridad'
                                     value={Prioridad}
                                     onChange={(e) => setPrioridad(e.target.value)}

                                    className="form-select form-select-solid  border-gray-300 " aria-label="Select example">
                                      <option selected hidden>Select</option>
                                      <option className="text-success" value="4">Low</option>
                                      <option className="text-warning" value="3">Medium</option>
                                      <option className="text-danger" value="2">High</option>
                                    </select>
                                </div>
                                 {/* Campos solicitud */}
                                 <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>Description</label>
                                    <textarea
                                      className="form-control form-control-solid border-gray-300"
                                      placeholder="Description of the problem (required)"
                                      required
                                      rows={10}
                                      id='Descripcion'
                                      value={Descripcion}
                                      onChange={(e) => setDescripcion(e.target.value)}
                                    />
                                </div>
                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0'>Attach (Drag and drop screenshots or browse your device)</label>
                                    <input
                                      type="file"
                                      multiple
                                      className="form-control form-control-solid border-gray-300 "
                                      placeholder="Arrastra y suelta capturas de pantalla"
                                      id='files'
                                      
                                      onChange={(e) => handleChange(e)}
                                     
                                    />
                                </div>
                                {/* Campos solicitud */}
                                <div className="fv-row mb-3">
                                  <div className="form-check form-switch form-check-custom form-check-solid">
                                      <input className="form-check-input border border-info" 
                                      type="checkbox" 
                                      checked={isChecked}
                                      onChange={handleCheckboxChange}
                                      value="activar" 
                                      id="activador"
                                      />
                                      <label className="form-check-label text-info fw-bolder f-parrafo" >
                                        I WANT TO SEND A RESPONSE OF THE CASE TO ANOTHER PERSON
                                      </label>
                                  </div>
                                </div>

                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label hidden={!isChecked} className='form-label fw-bolder text-dark fs-6 mb-0'>Contact Name</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-solid border-gray-300"
                                      placeholder="Escribe los correos de soporte"
                                      hidden={!isChecked}
                                      id='Contacto'
                                      value={Contacto}
                                      onChange={(e) => setContacto(e.target.value)}
                                    />
                                </div>

                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label hidden={!isChecked} className='form-label fw-bolder text-dark fs-6 mb-0'>Contact Email</label>
                                    <input
                                      type="email"
                                      className="form-control form-control-solid border-gray-300 "
                                      placeholder="Escribe los correos de soporte"
                                      hidden={!isChecked}
                                      id='Correo'
                                      value={Correo}
                                      onChange={(e) => setCorreo(e.target.value)}
                                     
                                      
                                    />
                                </div>
                                <div className='fv-row mb-3 f-parrafo' hidden= {!isChecked}>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0'>Contact Phone</label>
                                    <PhoneInput
                                        country={'mx'}
                                        value={phone_number}
                                        onChange={phone => setPhone_number(phone)}
                                        inputClass={"bg-light-info text-info border-gray-300"}
                                      />
                                </div>
                                {/* begin::Action */}
                                <div className='d-grid mb-10 justify-content-center'>
                                  
                                  <button
                                    type='submit'
                                    id='kt_sign_in_submit'
                                    className='btn btn-primary'
                                  >
                                    {!loading && <span className='indicator-label'>Save</span>}
                                    {loading && (
                                      <span className='indicator-progress' style={{display: 'block'}}>
                                        Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                      </span>
                                    )}
                                  </button>
                                </div>
                                
                                {/* end::Action */}

                            </form>
                        </div>
                        
                    </div>
                    

                </div>
        
                <div className='col-xl-3'></div>
              </div>
              {/* end::Row */} 
            </>

        
      
    )
    }